// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1QNji","content":"LoadingAlert_content__3wBuz"};